<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">`{{ userName }}`用户绑定车库</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        v-if="showModal"
        :columns="columns"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        :url="action"
        :show-add="false"
        :pager="false"
        :border="false"
      />
    </div>
  </Modal>
</template>

<script>
import { getConfigItem } from '@/apis'
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'ParkingAgentListDialog',
  components: { TableWrapper },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    userName: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      modalForm: false,
      submit: false,
      modCount: 0,
      entityId: 0
    }
  },
  computed: {
    offsetHeight() {
      return 480
    },
    action() {
      return this.$config.apiContextPath + '/partner/relation/user/' + this.id
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 70, align: 'center' },
        { title: '绑定车库', align: 'center', key: 'parkingName', sortable: true, ellipsis: true, tooltip: true },
        { title: '同步状态', align: 'center', key: 'syncStatus', sortable: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.syncStatus === 1 ? 'green' : 'red' }
            }, params.row.syncStatus === 1 ? '已同步' : '未同步')
          }
        },
        { title: '同步时间', align: 'center', key: 'syncTime', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.syncTime || '---')
          }
        },
        { title: '操作', align: 'center', width: 120,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', cursor: 'pointer', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showSyncModalDialog(this.id, params.row.parkingId, params.row.parkingName)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
                h('span', {}, '同步')
              ])
            ])
          }
        }
      ]
    }
  },
  watch: {
    showModal(val) {
    }
  },
  methods: {
    async getMemberSyncTimeout() {
      const res = await getConfigItem(this.$config.apiContextPath + '/config', 'NS_SYSTEM', 'SYNC_MEMBER_TIMEOUT')
      if (res.data && res.data.content.length > 0) {
        try {
          const configItem = res.data.content[0]
          this.timeout = parseInt(configItem.value)
        } catch (err) {
          console.log('Invalid timeout')
        }
      }
    },
    async showSyncModalDialog(id, parkingId, parkingName) {
      const _this = this
      this.getMemberSyncTimeout()
      this.$Modal.confirm({
        title: '确认同步用户数据么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, parkingName)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/partner/member?memberId=' + id + '&parkingId=' + parkingId,
            method: 'POST'
          }).then(res => {
            this.$Notice.success({
              title: '数据同步成功',
              desc: '用户 `' + parkingName + '` 车库数据同步成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '用户 `' + parkingName + '` 车库数据同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.entityId = 0
      this.$emit('on-close', changed)
    }
  }
}
</script>
